import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CheckTabsChangesGuard} from 'src/app/guards/check-tabs-changes.guard';
import {PermissionsGuard} from 'src/app/guards/permissions.guard';
import {AddingEmployeeComponent} from './adding-employee/adding-employee.component';
import {BankInfoComponent} from './bank-info/bank-info.component';
import {GeneralRecruiterComponent} from './general-recruiter/general-recruiter.component';
import {GeneralComponent} from './general/general.component';
import {HrDataComponent} from './hr-data/hr-data.component';
import {PeDataComponent} from './pe-data/pe-data.component';
import {PersonalDataComponent} from './personal-data/personal-data.component';
import {ProfessionalDataComponent} from './professional-data/professional-data.component';
import {ProfileComponent} from './profile/profile.component';
import {SalaryRecruiterComponent} from './salary-recruiter/salary-recruiter.component';
import {SalaryComponent} from './salary/salary.component';
import {SalaryExtendedComponent} from './salary-extended/salary-extended.component';
import {UserRoles, roles} from 'src/app/shared/utils/roles';
import {BcoinComponent} from './bcoin/bcoin.component';
import {PersonalRecruiterComponent} from './personal-recruiter/personal-recruiter.component';
import {AccessDataResolver} from 'src/app/guards/user-access.resolver';
import {CheckPendingStatusGuard} from 'src/app/guards/check-pending-status.guard';
import {SalaryRecruiterPermissionsGuard} from 'src/app/guards/salary-recruiter-permissions.guard';

const routes: Routes = [
  {
    path: 'adding',
    component: AddingEmployeeComponent,
    canActivate: [PermissionsGuard],
    data: {
      permission: [
        ...roles.RECRUITMENT_DEPARTMENT,
        ...roles.DELIVERY_DEPARTMENT,
      ],
    },
    children: [
      {
        path: 'general',
        component: GeneralRecruiterComponent,
        canDeactivate: [CheckTabsChangesGuard],
      },
      {
        path: 'salary',
        component: SalaryRecruiterComponent,
        canDeactivate: [CheckTabsChangesGuard],
      },
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: ':id',
    component: ProfileComponent,
    resolve: {accessData: AccessDataResolver},
    children: [
      {
        path: 'general',
        component: GeneralComponent,
        canDeactivate: [CheckTabsChangesGuard],
      },
      {
        path: 'personal-data',
        component: PersonalDataComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
            ...roles.CEO,
            ...roles.DELIVERY_DEPARTMENT,
            ...roles.LINE_MANAGEMENT,
            ...roles.ADMIN,
          ],
        },
      },
      {
        path: 'personal-recruiter',
        component: PersonalRecruiterComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [...roles.RECRUITMENT_DEPARTMENT],
        },
      },
      {
        path: 'professional-data',
        component: ProfessionalDataComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
            ...roles.CEO,
            ...roles.DELIVERY_DEPARTMENT,
            ...roles.LINE_MANAGEMENT,
            ...roles.ADMIN,
          ],
        },
      },
      {
        path: 'hr-data',
        component: HrDataComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
            ...roles.CEO,
            ...roles.DELIVERY_DEPARTMENT,
            ...roles.LINE_MANAGEMENT,
          ],
        },
      },
      {
        path: 'salary-extended',
        component: SalaryExtendedComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.CEO,
            ...roles.DELIVERY_DEPARTMENT,
            ...roles.LINE_MANAGEMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
          ],
        },
      },
      {
        path: 'salary',
        component: SalaryComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [UserRoles.hrManager],
        },
      },
      {
        path: 'pe',
        component: PeDataComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [...roles.ACCOUNTANT_DEPARTMENT],
        },
      },
      {
        path: 'bank-info',
        component: BankInfoComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [...roles.ACCOUNTANT_DEPARTMENT],
        },
      },
      {
        path: 'bcoin',
        component: BcoinComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [PermissionsGuard],
        data: {
          permission: [...roles.HR_DEPARTMENT],
        },
      },
      {
        path: 'salary-recruiter',
        component: SalaryRecruiterComponent,
        canDeactivate: [CheckTabsChangesGuard],
        canActivate: [SalaryRecruiterPermissionsGuard, CheckPendingStatusGuard],
      },
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
